const getInitialProductVariants = (categoryHandle, skintone) => {
    return `{
        collection(handle: "${categoryHandle}") {
            handle
            products(first: 24,
                filters: {
                    variantMetafield: {
                        namespace: "custom",
                        key: "skin_tone",
                        value: "${skintone}"
                    }
                }
            ) {
                edges {
                    node {
                        id
                        title
                        handle
                        availableForSale
                        descriptionHtml
                        totalInventory
                        featuredImage {
                            altText
                            url
                        }
                        images(first: 200) {
                            edges {
                                node {
                                    url
                                }
                            }
                        }
                        variants(first: 50) {
                            edges {
                                node {
                                    id
                                    torsoOverlayValue: metafield(
                                        namespace: "custom"
                                        key: "torso_overlay"
                                    ) {
                                        value
                                    }
                                    skintoneValue: metafield(
                                        namespace: "custom"
                                        key: "skin_tone"
                                    ) {
                                        value
                                    }
                                    reverseImage: metafield(
                                        namespace: "custom"
                                        key: "reverse_image"
                                    ) {
                                        reference {
                                            ... on MediaImage {
                                              image {
                                                url
                                              }
                                            }
                                        }
                                    }
                                    image {
                                        altText
                                        url
                                    }
                                    title
                                    priceV2 {
                                        amount
                                    }
                                    compareAtPriceV2 {
                                        amount
                                    }
                                    availableForSale
                                }
                            }
                        }
                        tags
                        productWarningValue: metafield(
                            namespace: "custom"
                            key: "product_warning"
                        ) {
                            value
                        }
                    }
                    cursor
                }
                pageInfo {
                    hasNextPage
                }
            }
        }
    }`;
};

export default getInitialProductVariants;
